

























import { defineComponent, onUnmounted, ref, watch } from '@nuxtjs/composition-api';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';

import useVehicleYears from '~/composables/useVehicleYears';

import YearSelector from '../YearSelector/YearSelector.vue';
import useVehiclesByRego from './useVehiclesByRego';
import VehiclesRegoSearchForm from './VehiclesRegoSearchForm.vue';

interface RegoSearchLookupEmitProps {
  emit: {
    (event: 'input', val: { vehicles: PartsDbVehicleSummary[]; exactYear: string | null }): void;
  };
}

export default defineComponent({
  components: {
    YearSelector,
    VehiclesRegoSearchForm,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup(_: unknown, { emit }: RegoSearchLookupEmitProps) {
    const rego = ref('');
    const state = ref('');

    const { reset, vehicles, fetchVehicles, loading: loadingVehicles, error } = useVehiclesByRego();

    const { noExactYearFound, exactYear, possibleVehicleYears, updateExactYear } = useVehicleYears({
      vehicles,
    });

    onUnmounted(() => {
      reset();
    });

    watch([vehicles, exactYear], () => {
      emit('input', { vehicles: vehicles.value, exactYear: exactYear.value });
    });

    const handleSubmit = async (fetchedRego: string, fetchedState: string) => {
      rego.value = fetchedRego;
      state.value = fetchedState;

      await fetchVehicles(fetchedRego, fetchedState);
    };

    return {
      rego,
      state,
      handleSubmit,
      noExactYearFound,
      possibleVehicleYears,
      updateExactYear,
      loadingVehicles,
      error,
    };
  },
});
